import { CALL_API } from "../api.middleware";
import {
  FETCH_PORTFOLIOS,
  FETCH_PORTFOLIOS_SUCCESS,
  GET_AMC_DETIALS,
  PORTFOLIO_RESPONSE,
  GET_UNCLAIMED_PAYOUTS,
  UNCLAIMED_PAYOUT_PAYLOAD,
  GET_UNCLAIMED_PAYOUTS_SUCCESS,
} from "../types/portfolio";

export const getPortfolio =
  (body?: any) =>
  async (dispatch: any): Promise<PORTFOLIO_RESPONSE | undefined> => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: `/distributor/getSchemeDetails`,
          method: "POST",
          types: [FETCH_PORTFOLIOS, FETCH_PORTFOLIOS_SUCCESS],
          isNctNew: true,
          body,
          // enableFixture: true,
          json: `portfolioSummary.json`,
        },
      });
    } catch (error: any) {
      // throw error
      throw error;
    }
  };

export const getAmcDetails = (body: any) => {
  return {
    type: GET_AMC_DETIALS,
    body,
  };
};
export const getUnclaimedPayouts =
  (body: UNCLAIMED_PAYOUT_PAYLOAD) =>
  async (dispatch: any): Promise<any> => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: `/user/getUnclaimedPayouts`,
          method: "POST",
          types: [GET_UNCLAIMED_PAYOUTS_SUCCESS, GET_UNCLAIMED_PAYOUTS],
          body,
          // enableFixture: true,
          json: `unclaimedPayout.json`,
        },
      });
    } catch (error: any) {
      throw error;
    }
  };
